import script from "./match.vue?vue&type=script&lang=ts&setup=true"
export * from "./match.vue?vue&type=script&lang=ts&setup=true"

import "./match.vue?vue&type=style&index=0&id=766b8576&lang=scss&scoped=true"
import "./match.vue?vue&type=style&index=1&id=766b8576&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766b8576"]])

export default __exports__